/**
 * @generated SignedSource<<a0b454746378c581f029c70669511330>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalisedVideo_Settings_Fragment$data = {
  readonly pvImages: ReadonlyArray<{
    readonly image: {
      readonly id: string;
      readonly mediaItemUrl: string | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "personalisedVideo_Settings_Fragment";
};
export type personalisedVideo_Settings_Fragment$key = {
  readonly " $data"?: personalisedVideo_Settings_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"personalisedVideo_Settings_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "personalisedVideo_Settings_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyInfo_Znglyinfo_pvImages",
      "kind": "LinkedField",
      "name": "pvImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaItem",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mediaItemUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo_Znglyinfo",
  "abstractKey": null
};

(node as any).hash = "bad6f1392d78c7b0e250dc1386c833ae";

export default node;
